var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages"},[_c(_vm.currentView,{ref:"page",tag:"component",on:{"playEnd":function($event){return _vm.playNext()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }